import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICBSCustomerDetails } from 'Models/BOB/ResponseModels'
import { ICBSAssuredDetails } from 'Models/BOB/ResponseModels/CBS/CBSCustomerDetails'
import { IAssuredDetailsForm } from 'Pages/Life/SuitabilityMatrixSteps/AssuredDetails/AssuredDetailsForm'

export interface ICbsDataStoreValues {
  customerDetailsArray: ICBSCustomerDetails[]
  customerDetails?: ICBSCustomerDetails
  customerDetailsTemp?: ICBSCustomerDetails
  customerSelectedAccountIndex: number
  assuredDetailsArray: ICBSCustomerDetails[]
  assuredDetails?: ICBSCustomerDetails
  assuredDetailsTemp?: ICBSCustomerDetails
  assuredSelectedAccountIndex: number
  relationship?: string
  lifeAssuredCbsInput: {
    type: string
    value: string
  }
  PayorCbsInput: {
    type: string
    value: string
  }
  pan?: string
  isBOBCustomer: boolean
  cbsDataId?: number
  // assuredManuallyFilledFormData?: IAssuredDetailsForm
}

const initialState: ICbsDataStoreValues = {
  customerDetailsArray: [],
  customerSelectedAccountIndex: -1,
  assuredSelectedAccountIndex: -1,
  assuredDetailsArray: [],
  isBOBCustomer: true,
  lifeAssuredCbsInput: {
    type: 'customer',
    value: '',
  },
  PayorCbsInput: {
    type: 'customer',
    value: '',
  },
  cbsDataId: 0,
  // customerDetails: {},
}

const cbsDataSlice = createSlice({
  name: 'cbsDataSlice',
  initialState: initialState,
  reducers: {
    updateCustomerArrayData: (state, action: PayloadAction<ICBSCustomerDetails[]>) => {
      state.customerDetailsArray = action.payload
    },
    updateCustomerData: (state, action: PayloadAction<ICBSCustomerDetails>) => {
      state.customerDetails = action.payload
    },
    updateCustomerDataTemp: (state, action: PayloadAction<ICBSCustomerDetails>) => {
      state.customerDetailsTemp = action.payload
    },
    updateCustomerSelectedAccountIndex: (state, action: PayloadAction<number>) => {
      state.customerSelectedAccountIndex = action.payload
    },
    updateCustomerPaId: (state, action: PayloadAction<string>) => {
      if (state.customerDetails) {
        state.customerDetails.customer_id = action.payload
      }
    },
    updateCustomerTempPaId: (state, action: PayloadAction<string>) => {
      if (state.customerDetailsTemp) {
        state.customerDetailsTemp.customer_id = action.payload
      }
    },
    updateCustomerLaId: (state, action: PayloadAction<string>) => {
      if (state.assuredDetails) {
        state.assuredDetails.customer_id = action.payload
      }
    },
    updateCustomerTempLaId: (state, action: PayloadAction<string>) => {
      if (state.assuredDetailsTemp) {
        state.assuredDetailsTemp.customer_id = action.payload
      }
    },
    updateCustomerIsSmoker: (state, action: PayloadAction<boolean>) => {
      if (state.customerDetails) {
        state.customerDetails.is_smoker = action.payload
      }
    },
    updateAssuredArrayData: (state, action: PayloadAction<ICBSCustomerDetails[]>) => {
      state.assuredDetailsArray = action.payload
    },
    updateAssuredData: (state, action: PayloadAction<ICBSCustomerDetails | undefined>) => {
      state.assuredDetails = action.payload
    },
    updateAssuredNameData: (
      state,
      action: PayloadAction<{
        first_name: string
        middle_name: string
        last_name: string
      }>,
    ) => {
      state.assuredDetails = {
        first_name: action.payload.first_name,
        middle_name: action.payload.middle_name,
        last_name: action.payload.last_name,
        account_details: [],
        addresses: [],
      }
    },
    updateAssuredDataTemp: (state, action: PayloadAction<ICBSCustomerDetails | undefined>) => {
      state.assuredDetailsTemp = action.payload
    },
    updateAssuredIsSmoker: (state, action: PayloadAction<boolean>) => {
      if (state.assuredDetails) {
        state.assuredDetails.is_smoker = action.payload
      }
    },
    updateAssuredSelectedAccountIndex: (state, action: PayloadAction<number>) => {
      state.assuredSelectedAccountIndex = action.payload
    },
    updateRelationship: (state, action: PayloadAction<string>) => {
      state.relationship = action.payload
    },
    updateLifeAssuredCbsInput: (
      state,
      action: PayloadAction<{
        type: string
        value: string
      }>,
    ) => {
      state.lifeAssuredCbsInput = action.payload
    },
    updatePayorCbsInput: (
      state,
      action: PayloadAction<{
        type: string
        value: string
      }>,
    ) => {
      state.PayorCbsInput = action.payload
    },
    updatePan: (state, action: PayloadAction<string>) => {
      state.pan = action.payload
    },
    updateIsBOBCustomer: (state, action: PayloadAction<boolean>) => {
      state.isBOBCustomer = action.payload
    },
    updateCBSDataId: (state, action: PayloadAction<number>) => {
      state.cbsDataId = action.payload
    },
    // updateAssuredManualFilledData: (state, action: PayloadAction<IAssuredDetailsForm>) => {
    //   state.assuredManuallyFilledFormData = action.payload
    // },
    updateCbsAllData: (state, action: PayloadAction<ICbsDataStoreValues>) => {
      const {
        customerDetailsArray,
        customerDetails,
        customerSelectedAccountIndex,
        assuredDetailsArray,
        assuredDetails,
        assuredSelectedAccountIndex,
        relationship,
        PayorCbsInput,
        pan,
        isBOBCustomer,
        lifeAssuredCbsInput,
        assuredDetailsTemp,
        customerDetailsTemp,
        cbsDataId,
      } = action.payload
      if (customerDetailsArray !== undefined) {
        state.customerDetailsArray = customerDetailsArray
      }
      if (customerDetails !== undefined) {
        state.customerDetails = customerDetails
      }
      if (customerDetailsTemp !== undefined) {
        state.customerDetailsTemp = customerDetailsTemp
      }
      if (customerSelectedAccountIndex !== undefined) {
        state.customerSelectedAccountIndex = customerSelectedAccountIndex
      }
      if (assuredDetailsArray !== undefined) {
        state.assuredDetailsArray = assuredDetailsArray
      }
      if (assuredDetails !== undefined) {
        state.assuredDetails = assuredDetails
      }
      if (assuredDetailsTemp !== undefined) {
        state.assuredDetailsTemp = assuredDetailsTemp
      }
      if (assuredSelectedAccountIndex !== undefined) {
        state.assuredSelectedAccountIndex = assuredSelectedAccountIndex
      }
      if (relationship !== undefined) {
        state.relationship = relationship
      }
      if (PayorCbsInput !== undefined) {
        state.PayorCbsInput = PayorCbsInput
      }
      if (pan !== undefined) {
        state.pan = pan
      }
      if (isBOBCustomer !== undefined) {
        state.isBOBCustomer = isBOBCustomer
      }
      if (lifeAssuredCbsInput !== undefined) {
        state.lifeAssuredCbsInput = lifeAssuredCbsInput
      }
      if (cbsDataId != undefined) {
        state.cbsDataId = cbsDataId
      }
    },
    resetCbsAllDataExceptPayorCbsInput: (state) => {
      return {
        ...initialState,
        PayorCbsInput: state.PayorCbsInput,
      }
    },
    resetCbsAllData: () => initialState,
  },
})

const { reducer } = cbsDataSlice

const {
  updateCustomerData,
  updateAssuredData,
  updateAssuredNameData,
  // updateAssuredManualFilledData,
  updateRelationship,
  updateCustomerPaId,
  updateCustomerLaId,
  updateCustomerArrayData,
  updateAssuredArrayData,
  updatePan,
  updateLifeAssuredCbsInput,
  updateIsBOBCustomer,
  updateCustomerSelectedAccountIndex,
  updateAssuredSelectedAccountIndex,
  updateCbsAllData,
  resetCbsAllData,
  resetCbsAllDataExceptPayorCbsInput,
  updatePayorCbsInput,
  updateAssuredIsSmoker,
  updateCustomerIsSmoker,
  updateAssuredDataTemp,
  updateCustomerDataTemp,
  updateCustomerTempLaId,
  updateCustomerTempPaId,
  updateCBSDataId,
} = cbsDataSlice.actions

export {
  reducer as cbsDataReducer,
  updateCustomerData,
  updateAssuredData,
  updateAssuredNameData,
  // updateAssuredManualFilledData,
  updateRelationship,
  updateCustomerPaId,
  updateCustomerLaId,
  updateCustomerArrayData,
  updateAssuredArrayData,
  updatePan,
  updateLifeAssuredCbsInput,
  updateIsBOBCustomer,
  updateCustomerSelectedAccountIndex,
  updateAssuredSelectedAccountIndex,
  updateCbsAllData,
  resetCbsAllDataExceptPayorCbsInput,
  resetCbsAllData,
  updatePayorCbsInput,
  updateAssuredIsSmoker,
  updateCustomerIsSmoker,
  updateAssuredDataTemp,
  updateCustomerDataTemp,
  updateCustomerTempLaId,
  updateCustomerTempPaId,
  updateCBSDataId,
}
